// The vendor's remembered active store (per browser). The server re-validates it on every request
// (X-Store-Id is only a request; ownership is checked server-side), so this is a convenience, not security.
const KEY = "s24_active_store";

export function readActiveStore() {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
}

/** Remembered store id, but only for the given user. */
export function getActiveStoreId(userId) {
  const v = readActiveStore();
  return v && v.uid === userId ? v.sid : null;
}

export function setActiveStore(userId, storeId) {
  try { localStorage.setItem(KEY, JSON.stringify({ uid: userId, sid: storeId })); } catch { /* storage unavailable */ }
}

export function clearActiveStore() {
  try { localStorage.removeItem(KEY); } catch { /* storage unavailable */ }
}
